import { get } from 'lodash'

export function formatDecimalNumber(
  n: number,
  minimumFractionDigits = 2,
  maximumFractionDigits = 10,
): string {
  return (n || 0).toLocaleString(get(global, 'locale') ?? 'de', {
    minimumFractionDigits,
    maximumFractionDigits,
  })
}
